<template>
<div class="containers">
    <loader v-if="loadingScreen == true && valid == 'Y' && flagAddKlinik == 'Y'" object="#306bdd" style="z-index: 9999" color1="#ffffff" color2="#ffffff" size="7" speed="1" bg="#ffffff" objectbg="#ffffff" opacity="60" disableScrolling="true" name="dots"></loader>
    <div v-if="goArea == true && valid == 'Y' && flagAddKlinik == 'Y'" class="area-edit">
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalHasil"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div :style="modalConfirm == true && 'background-color:darkgrey;opacity:0.8'" class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Hasil Tes {{dataJenisTes}} Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalHasil = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div :style="modalConfirm == true && 'background-color:darkgrey;opacity:0.8'" style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].nik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nomor KTP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].noKtp}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Lahir
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].tanggalLahir}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nama Atasan
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].namaAtasan}}
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].edit == 'V'" class="mt-2">
                        <CCol sm="3">
                            Hasil Tes
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold" :style="'color:'+datasDetail[dataShowHasil].color">{{datasDetail[dataShowHasil].status}}
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].edit == 'V' && datasDetail[dataShowHasil].urlKlinik != '-'" class="mt-2">
                        <CCol sm="3">
                            Bukti Tes (PDF)
                        </CCol>
                        <CCol sm="9">
                            <CButton @click="showBuktiPDF(datasDetail[dataShowHasil].urlKlinik)" variant="outline" class="btn btn-danger">Unduh Hasil Tes</CButton>
                        </CCol>
                    </CRow>
                    <CRow v-if="datasDetail[dataShowHasil].edit == 'V' && datasDetail[dataShowHasil].urlKlinik == '-'" class="mt-3">
                        <CCol sm="3">
                            Upload Bukti Tes (PDF)
                        </CCol>
                        <CCol sm="9">
                            <CButton v-if="datasDetail[dataShowHasil].urlKlinik == '-'" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih File Maks 2MB</CButton>
                            <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display:none"  id="inputFile" class="hide" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                        <CCol v-if="datasDetail[dataShowHasil].edit == 'Y'" sm="6"></CCol>
                        <CCol v-if="datasDetail[dataShowHasil].edit == 'V'" sm="12"></CCol>
                        <CCol v-if="datasDetail[dataShowHasil].edit == 'Y'" sm="3">
                            <CButton @click="openConfirm('1')" class="w-100" color="danger"><span v-if="idJenisTes == '11'">Positif</span><span v-if="idJenisTes == '12'">Reaktif</span></CButton>
                        </CCol>
                        <CCol v-if="datasDetail[dataShowHasil].edit == 'Y'" sm="3">
                            <CButton @click="openConfirm('2')" class="w-100" color="primary"><span v-if="idJenisTes == '11'">Negatif</span><span v-if="idJenisTes == '12'">Non Reaktif</span></CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalConfirm"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Hasil <span v-if="flagHasil == '1'" class="font-weight-bold text-danger"><span v-if="idJenisTes == '11'">Positif</span><span v-if="idJenisTes == '12'">Reaktif</span></span><span v-if="flagHasil == '2'" class="font-weight-bold text-primary"><span v-if="idJenisTes == '11'">Negatif</span><span v-if="idJenisTes == '12'">Non Reaktif</span></span></div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalConfirm = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px;margin-top:48px;;margin-bottom:48px;">
                    <CRow>
                        <CCol sm="12">
                            Apakah anda yakin peserta <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span> memiliki hasil tes <span v-if="flagHasil == '1'" class="font-weight-bold text-danger"><span v-if="idJenisTes == '11'">Positif</span><span v-if="idJenisTes == '12'">Reaktif</span></span><span v-if="flagHasil == '2'" class="font-weight-bold text-primary"><span v-if="idJenisTes == '11'">Negatif</span><span v-if="idJenisTes == 'RTA'">Non Reaktif</span></span>?
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6"></CCol>
                    <CCol sm="2">
                        <CButton style="width: 100%!important" @click="modalConfirm = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                    <CCol sm="2">
                        <CButton @click="submitHasil(flagHasil)" class="w-100" color="primary">Ya, Simpan</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalHadir"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Kehadiran Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalHadir = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold">{{datasDetail[dataShowHasil].nama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].nik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nomor KTP
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].noKtp}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Lahir
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].tanggalLahir}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nama Atasan
                        </CCol>
                        <CCol sm="9">
                            :  {{datasDetail[dataShowHasil].namaAtasan}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px;">
                        <CCol sm="8"></CCol>
                        <CCol sm="2">
                            <CButton style="width: 100%!important" @click="modalHadir = false" class="btn-cancel">Batal</CButton>
                        </CCol>
                        <CCol sm="2">
                            <CButton @click="submitHadir()" class="w-100" color="primary">Ya, Hadir</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <div style="padding-top: 12px;padding-left: 20px;padding-right: 20px;padding-bottom: 6px !important;background-color: white;">
            <CRow>
                <CCol sm="9">
                    <CRow>
                        <CCol sm="4">
                            <span>Nama Lokasi</span>
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataNamaKantor}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Tanggal</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTanggal}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Jenis Tes</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataJenisTes}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Mendaftar</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalMendaftar}} Peserta
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Reaktif/Positif</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalReaktif}} Peserta
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Total Non Reaktif/Negatif</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataTotalNonReaktif}} Peserta
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="5">
                            <hr/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Nama Klinik</span>
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataNama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Alamat Klinik</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataAlamat}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>No. Telp Klinik</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataNo}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Email Klinik</span>
                        </CCol>
                        <CCol sm="8">
                            : {{dataEmail}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol sm="4">
                            <span>Penanggung Jawab</span>
                        </CCol>
                        <CCol sm="8">
                            : <span class="font-weight-bold">{{dataPenanggungJawab}}</span>
                        </CCol>
                    </CRow>
                </CCol>
                <CCol v-if="flagImage == true" sm="3 text-center">
                    <img v-if="imageQR != ''" :src="'data:image/jpeg;base64,' + imageQR" style="border-radius: 8px" width="150" height="150"/>
                    <CRow class="mt-2">
                        <CCol sm="12">
                            <CButton @click="exportPdf()" color="danger" variant="outline">Export QR Code</CButton>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </div>
        <hr class="mt-3 mb-2" />
        <div class="search-area ">
            <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CRow>
                <CCol sm="6" class="pr-1">
                    <input type="text"
                            class="form-control"
                            v-model="searchPegawai"
                            placeholder="Cari Peserta"
                    >
                </CCol>
                <CCol sm="2" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilterJam" class="form-control" v-model="filterJam" placeholder="Jam Pelaksanaan"></model-select>
                </CCol>
                <CCol sm="2" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilterStatus" class="form-control" v-model="filterStatus" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2 pl-1">
                    <CButton @click="findDataDetail()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="pageDetail == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePageDetail('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="pageDetail == totalPageDetail" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePageDetail('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePageDetail(pageDetail)" v-if="totalPageDetail != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="pageDetail" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="pageDetail" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPageDetail}} - {{lastPageDetail}}</span> of {{totalRowDetail}}</span>
                </CCol>
            </CRow>
        </div>
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th class="text-left" style="width:100px;max-width:100px">Nama Pegawai</th>
                        <th class="text-left" style="width:75px;max-width:75px">Nomor KTP</th>
                        <th class="text-left" style="width:60px;max-width:60px">Tgl Lahir</th>
                        <th class="text-left" style="width:100px;max-width:100px">Nama Atasan</th>
                        <th class="text-left" style="width:25px;max-width:25px">Jam</th>
                        <th class="text-left" style="width:75px;max-width:75px;">Status</th>
                        <th class="text-left" style="width:50px;max-width:50px">Action</th>
                    </tr>
                    <tr>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow class="mb-5">
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="datasDetail.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errorMessageDetail}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="datasDetail.length != 0">
                                <tr v-for="(body, id) in datasDetail" :key="id">
                                    <td style="width:100px;max-width:100px">
                                        <div class="row no-gutters">
                                            <div class="col-12 ellps">
                                                <span>{{body.nama}}</span>
                                            </div>
                                            <div class="col-12">
                                                <span style="font-size:12px; color:grey">{{body.nik}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:75px;max-width:75px">{{body.noKtp}}</td>
                                    <td style="width:60px;max-width:60px">{{body.tanggalLahir}}</td>
                                    <td style="width:100px;max-width:100px">{{body.namaAtasan}}</td>
                                    <td style="width:25px;max-width:25px">{{body.jam}}</td>
                                    <td :style="'color:'+body.color" style="width:75px;max-width:75px">{{body.status}}</td>
                                    <td style="width:50px;max-width:50px">
                                        <div class="text-center">
                                            <CButton v-if="body.edit == 'Y'" @click="openModalHasil(id)" class="btn btn-edit">Edit</CButton>
                                            <CButton v-if="body.edit == 'V'" @click="openModalHasil(id)" class="btn btn-edit">Result</CButton>
                                            <CButton v-if="body.edit == 'D'" @click="openModalHadir(id)" class="btn btn-edit">Hadir</CButton>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div v-if="valid != 'Y'" class="row">
        <div class="col-12 p-5 text-center" style="min-height: 100vh">
            <h3>{{pesan}}</h3>
        </div>
    </div>
    <div v-if="valid == 'Y' && flagAddKlinik == 'T'" class="row">
        <div class="col-12 p-5 text-center" style="min-height: 100vh">
            <CModal
                size="lg"
                :centered="true"
                color="white"
                :show.sync="modalAdd"
                :closeOnBackdrop="false"
                >
                <template #header-wrapper>
                    <div class="headers-modal">
                        <CRow>
                            <CCol sm="12 text-left">
                                <div>Data Klinik</div>
                            </CCol>
                        </CRow>
                    </div>
                </template>
                <template #body-wrapper>
                    <div style="padding-right:20px;padding-left:20px">
                        <CRow class="mt-2 mb-5">
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12 text-left">
                                        <label>Nama Klinik/Instansi Petugas Tes</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="12">
                                        <input type="text" v-model="inputNama" class="form-control" placeholder="Nama Lengkap Klinik Kesehatan" />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3">
                                    <CCol sm="12 text-left">
                                        <label>Alamat Lengkap Klinik</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="12">
                                        <textarea v-model="inputAlamat" class="form-control" placeholder="Jalan. Klinik No. Klinik. Kota. Provinsi" />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3">
                                    <CCol sm="12 text-left">
                                        <label>No. Telp Klinik</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="12">
                                        <input type="text" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"  v-model="inputNo" class="form-control" placeholder="02123456" />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3">
                                    <CCol sm="12 text-left">
                                        <label>Alamat Email Klinik</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="12">
                                        <input type="email" v-model="inputEmail" class="form-control" placeholder="klinik@mail.com" />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3">
                                    <CCol sm="12 text-left">
                                        <label>Penanggung Jawab Tes</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="12">
                                        <input type="text" v-model="inputPenanggungJawab" class="form-control" placeholder="dr. nama penanggung jawab" />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3">
                                    <CCol sm="12 text-left">
                                        <label>Logo Klinik (JPG, JPEG, PNG)</label>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-1">
                                    <CCol sm="3">
                                        <div v-if="urlImage == ''" class="p-0">
                                            <CButton type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Logo Maks 2MB</CButton>
                                            <input type="file" accept=".jpeg, .jpg, .png" v-on:change="onFileChange" style="display:none"  id="inputFile" class="hide" />
                                        </div>
                                        <div v-else>
                                            <img :src="urlImage" width="56" height="56" />
                                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow v-if="errAlert != ''" class="mt-3">
                            <CCol sm="12">
                                <span class="text-danger">{{errAlert}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5" style="padding-bottom:40px">
                            <CCol sm="9"></CCol>
                            <CCol sm="3">
                                <CButton style="width:100%!important" @click="saveImage()" class="btn btn-primary">Simpan</CButton>
                            </CCol>
                        </CRow>
                    </div>
                </template>
                <template #footer-wrapper><span></span></template>
            </CModal>
        </div>
    </div>
</div>
</template>

<script>
import {DataApiRTA, DataApiUpload} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        ModelSelect
    },
    data() {
        return {
            success: true,
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // pagination Detail
            pageDetail: 1,
            sizeDetail: 20,
            totalRowDetail: 0,
            totalPageDetail: 1,
            firstPageDetail: 0,
            lastPageDetail: 0,
            closeIcon: require('../../../assets/menu/icon_close.svg'),

            idKantor: '',
            tanggalKantor: '',
            idJenis: '',
            flagAddKlinik: '',
            dataTanggal: '',
            dataNamaKantor: '',
            idJenisTes: '',
            dataJenisTes: '',
            dataTotalMendaftar: '',
            dataTotalReaktif: '',
            dataTotalNonReaktif: '',
            dataFilterJam: [],
            filterJam: {
                value: '',
                text: ''
            },
            dataFilterStatus: [],
            filterStatus: {
                value: '',
                text: ''
            },
            
            // datas
            datasDetail: [],
            valid: '',
            pesan: '',

            //error
            errorMessageDetail: '',

            modalHasil: false,
            dataShowHasil: '',
            unixHasil: '',
            flagImage: false,
            loadingScreen: false,

            flagHasil: '',
            modalConfirm: false,

            dataNama: '',
            dataAlamat: '',
            dataNo: '',
            dataEmail: '',
            dataPenanggungJawab: '',
            modalAdd: false,
            flagAddKlinik: '',
            inputNama: '',
            inputAlamat: '',
            inputNo: '',
            inputEmail: '',
            inputPenanggungJawab: '',
            errAlert: '',

            //image
            urlImage: '',
            showImage: '',
            urlPath: '',

            lvl: '',
            organisasi: '',
            flagSearch: false,

            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',
            validEmail: false,
            modalHadir: false
        }
    },
    computed: {
    },
    watch: {
        pageDetail() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchPegawai() {
            this.flagSearch = true
        },
        filterJam() {
            this.flagSearch = true
        },
        filterStatus() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        modalConfirm() {
            if(this.modalConfirm == false) {
                this.flagHasil = ''
            }
        },
        flagAddKlinik() {
            if(this.flagAddKlinik == 'T') {
                this.errAlert = ''
                this.inputNama = ''
                this.inputAlamat = ''
                this.inputNo = ''
                this.inputEmail = ''
                this.inputPenanggungJawab = ''
                this.modalAdd = true
            }
        },
        inputEmail() {
            this.validateEmail()
        }
    },
    methods: {
        openConfirm(val) {
            this.flagHasil = val
            this.modalConfirm = true
        },
        findDataDetail() {
            this.getDataDetail('null')
        },
        movePageDetail(direction) {
            if(direction == 'prev') {
                this.pageDetail = this.pageDetail -  1
            } else {
                this.pageDetail = this.pageDetail +  1
            }
            this.getDataDetail('null')
        },

        validatePageDetail(page) {
            if(page > this.totalPageDetail) {
                this.pageDetail = this.totalPageDetail
            }
        },
        getFilterDate() {
            DataApiRTA.get("public/rta/daftar/detail/lihat")
            .then(res => {
                this.dataFilterStatus = []
                this.dataFilterJam = []
                let response = res.data
                if(response.success == true) {
                    let onPushJam = {
                        value: '',
                        text: 'Semua Jam'
                    }
                    let onPushStatus = {
                        value: '',
                        text: 'Semua Status'
                    }
                    this.dataFilterJam.push(onPushJam)
                    this.dataFilterStatus.push(onPushStatus)
                    let datas = response.data
                    let temp = datas.data
                    let status = datas.listKeterangan
                    var i = 0
                    for(i=0;i<temp.length;i++) {
                        let keep = {
                            value: temp[i].unix,
                            text: temp[i].jam
                        }
                        this.dataFilterJam.push(keep)
                    }
                    var j = 0
                    for(j=0;j<status.length;j++) {
                        let save = {
                            value: status[j].unix,
                            text: status[j].keterangan
                        }
                        this.dataFilterStatus.push(save)
                    }
                    this.dataNamaKantor = datas.kantor
                    this.dataTanggal = datas.tanggal
                    this.dataTotalMendaftar = datas.mendaftar
                    this.idJenisTes = datas.idJenisTest
                    this.dataJenisTes = datas.keteranganJenisTest
                    this.dataTotalReaktif = datas.reaktif
                    this.dataTotalNonReaktif = datas.nonReaktif
                }
            })
        },
        getQRCode() {
            DataApiRTA.get("public/rta/qrcode/image")
            .then(res => {
                let temp = res.data
                this.imageQR = temp.data
                this.flagImage = true
                this.loadingScreen = false
            })
        },

        exportPdf() {
            this.loadingScreen = true
            DataApiRTA.get("public/rta/export/jadwal/pdf" , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.loadingScreen = false
            })
        },
        getDataDetail(intt) {
            if(this.flagSearch == true) {
                this.pageDetail = 1
            }
            if(intt == 'null') {
                this.loadingScreen = true
            }
            let limit = this.sizeDetail
            let page = this.pageDetail

            let payload = {
                idKantor: this.idKantor,
                pegawai: this.searchPegawai,
                limit: limit,
                pageIn: page,
                status: this.filterStatus.value,
                tanggal: this.tanggalKantor,
                jenisTest: this.idJenis,
                unixJadwal: this.filterJam.value
            }
            DataApiRTA.post("public/rta/absen/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datasDetail = response.data.data
                    this.totalRowDetail = response.data.row
                    this.firstPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + 1 )
                    this.lastPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + this.datasDetail.length )
                    this.totalPageDetail = Math.floor(this.totalRowDetail/this.sizeDetail)
                    let modAr = this.totalRowDetail%this.sizeDetail
                    if(modAr != 0) {
                        this.totalPageDetail = this.totalPageDetail + 1
                    } else {
                        //
                    }
                } else {
                    this.datasDetail = []
                    this.totalRowDetail = 0
                    this.firstPageDetail = 0
                    this.lastPageDetail = 0
                    this.totalPageDetail = 1
                    this.errorMessageDetail = response.message
                }
                this.loadingScreen = false
                this.flagSearch = false
            })
        },
        openModalHasil(id) {
            this.dataShowHasil = id
            this.unixHasil = this.datasDetail[id].unix
            this.modalHasil = true
        },
        closeModalHasil() {
            this.modalHasil = false
            this.unixHasil = ''
            this.dataShowHasil = ''
        },
        submitHasil(hasil) {
            this.loadingScreen = true
            let payload = {
                unix: this.unixHasil,
                hasilRta: hasil
            }
            DataApiRTA.post("public/rta/hasil/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalConfirm = false
                this.getFilterDate()
                this.getDataDetail('null')
                this.modalHasil = false
                this.currentAlertCounter = 3
                this.loadingScreen = false
            })
        },
        openModalHadir(id) {
            this.dataShowHasil = id
            this.modalHadir = true
        },
        submitHadir() {
            this.$store.state.loadingScreen = true
            let payload = {
                unixDaftar: this.datasDetail[this.dataShowHasil].unix
            }
            DataApiRTA.post("public/rta/absen/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalHadir = false
                this.getDataDetail('null')
                this.currentAlertCounter = 3
                this.$store.state.loadingScreen = false
            })
        },


        /**
         * 
         */
        getValue() {
            this.loadingScreen = true
            let data = this.$route.params.tokens
            let payload = {
                data: this.$route.params.tokens,
            }
            DataApiRTA.post("public/rta/jadwal/cek", payload)
            .then(res => {
                let response = res.data
                if(response.data.valid == 'Y') {
                    this.flagImage = false
                    let temp = response.data
                    this.valid = temp.valid
                    this.idKantor = temp.idKantor
                    this.lvl = temp.lvl
                    this.organisasi = temp.organisasi
                    this.tanggalKantor = temp.tanggal
                    this.idJenis = temp.jenisTest
                    localStorage.setItem("tokenRTA", temp.token)
                    if(response.data.lengkap == 'Y') {
                        this.flagAddKlinik = 'Y'
                        this.dataNama = temp.namaKlinik
                        this.dataEmail = temp.emailKlinik
                        this.dataAlamat = temp.alamatKlinik
                        this.dataPenanggungJawab = temp.penanggungJawab
                        this.dataNo = temp.teleponKlinik
                        this.errorMessageDetail = 'Find Your Data'
                        this.getFilterDate()
                        this.pesan = ''
                        this.getQRCode()
                    } else {
                        this.flagAddKlinik = 'T'
                        this.modalAdd = true
                    }
                } else {
                    this.valid = 'T'
                    this.pesan = response.data.pesan
                }
            })
        },
        saveKlinik() {
            if(this.inputNama == '' || this.inputAlamat == '' || this.inputNo == '' || this.inputEmail == '' || this.inputPenanggungJawab == '' ) {
                this.errAlert = '*Harap melengkapi data terlebih dahulu'
            } else {
                if(this.validEmail == false) {
                    this.errAlert = '*Email Tidak Valid'
                } else {
                    this.errAlert = ''
                    this.submitKlinik()
                }
            }
        },
        submitKlinik() {
            this.loadingScreen = true
            let payload = {
                alamatKlinik: this.inputAlamat,
                emailKlinik: this.inputEmail,
                namaKlinik: this.inputNama,
                penanggungJawab: this.inputPenanggungJawab,
                teleponKlinik: this.inputNo,
                urlLogo: this.urlPath
            }
            DataApiRTA.post("public/rta/jadwal/lengkap/simpan", payload)
            .then(res => {
                this.loadingScreen = false
                let response = res.data
                if(response.success == true) {
                    this.getValue()
                    this.modalAdd = false
                }
            })
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.saveKlinik()
                    } else {
                        alert('Upload Photo Failed !')
                        this.loading = false
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.saveKlinik()
            } else {
                this.urlPath = this.urlImage
                this.saveKlinik()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        loadFile(e) {
            this.loadingScreen = true
            let files = document.getElementById('inputFile').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
            this.uploadFile()
        },
        uploadFile() {
            if(parseInt(this.fileSize) > 2000000) {
                alert("Maaf, Maksimal lampiran 2MB")
                setTimeout(this.clearFile, 200);
                this.loadingScreen = false
            } else {
                this.prosessUpload()
            }
        },
        prosessUpload() {
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path
                        this.savePDF(this.urlFile)
                    } else {
                        alert('Upload File Failed !')
                        this.loadingScreen = false
                    }
                });
            } else if(this.file == '') {
                this.urlFile = ''
                this.loadingScreen = false
            }
        },
        savePDF(url) {
            let unix = this.datasDetail[this.dataShowHasil].unix
            let payload = {
                unix: unix,
                urlFile: url
            }
            DataApiRTA.post("public/rta/hasil/file/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.getDataDetail('submit')
                    } else {
                        alert("Gagal Simpan File")
                        this.loadingScreen = false
                    }
                } else {
                    alert("Gagal Simpan File")
                    this.loadingScreen = false
                }
            })
        },
        clearFile() {
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },
        showBuktiPDF(base) {
            this.loadingScreen = true
            DataApiUpload.get('load/' + base)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
                this.loadingScreen = false
            })
        },
        validateEmail() {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const Regex = re.test(String(this.inputEmail).toLowerCase())
            if(Regex == true) {
                this.validEmail = true
            } else {
                this.validEmail = false
            }
        }
    },
    mounted() {
        this.getValue()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>